import React from "react";
import { Modal } from "react-bootstrap";
import "./Message_Modal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const Message_Modal = (props) => {
  setTimeout(() => {
    props?.onHide();
  }, 5000);

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="Message_Modal modal-holder"
    >
      <Modal.Header>
        <Modal.Title>
          <div className="row">
            <div className="col-sm-6 custom_col">MESSAGE FROM FUNREP</div>
            <div className="col-sm-6">
              <p className="right_text">
                फनरेप की तरफ से सन्देश
                <div
                  className="icon_holder"
                  onClick={() => {
                    props?.onHide();
                  }}
                >
                  <FontAwesomeIcon icon={faXmark} className="icon" />
                </div>
              </p>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="row">
          <div className="col-sm-6 custom_col">
            <div className="content_div">
              <p className="red_title">Dearest Customer,</p>

              <p className="descn">
                It has come to our attention that here are many duplicate
                versions of our software running in the market.
              </p>
              <p className="descn">
                Many innocent players have been cheated by them. So Kindly
                remember the url:{" "}
                <span className="link_text">
                  "www.fun-rep.pro/results.aspx"
                </span>{" "}
                & always check the last 5 Draw No's on this site from the one
                which is shown on the actual game.
              </p>

              <p className="descn">
                If the Numbers do not match then you would know that you 20 are
                not playing on the original funrep Website
              </p>
              <p className="descn">
                Please be alert and do this check everytime
              </p>
              <p className="descn">Regards funrep</p>
            </div>
          </div>

          <div className="col-sm-6">
            <div className="content_div">
              <p className="red_title">प्रिय ग्राहक,</p>

              <p className="descn">
                हमे यह पता चला हे की बाजार में हमारे जैसे नकली गेम चल रहे हे ।{" "}
              </p>
              <p className="descn">
                इन नकली गेम की वजह बहुत सारे लोगों के साथ धोखा हो रहा है। इस
                समस्या के समाधान के लिए हमारे दिए हुए इस लिंक:{" "}
                <span className="link_text">
                  "www.fun-rep.pro/results.aspx"
                </span>{" "}
                जाकर आखिरी ५ ड्रा नम्बर को मिला ले जो आपके द्वारा खेले जा रहे
                है।
              </p>
              <p className="descn">
                यदि ये नम्बर ना मिले तो समझ जाये की आप फनरेप के गेम नही खेल रहे
                है और आपके साथ धोखा हो रहा है।
              </p>
              <p className="descn">
                कृपया सावधान रहे और गेम के नम्बर मिला Alpse आभारी फनरेप.
              </p>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Message_Modal;
